// extracted by mini-css-extract-plugin
export default {"rfIdDetailsRow":"delete-rfid_rfIdDetailsRow__y+oh5"};